import { createVNode } from 'vue';
import { ZIcon } from '../.metadata/index.js';
export function $icon(name, size, color) {
  return createVNode(ZIcon, {
    name,
    color,
    width: size,
    height: size
  });
}
export function $iconName(name) {
  return name;
}